// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Traffic Config API
 * traffic-config-api manages traffic configuration for the Aura platform.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-infra@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const V1CloudProvider = {
  CloudProviderAzure: 'azure',
  CloudProviderAws: 'aws',
  CloudProviderGcp: 'gcp',
} as const;
export type V1CloudProvider =
  (typeof V1CloudProvider)[keyof typeof V1CloudProvider];

export function instanceOfV1CloudProvider(value: any): boolean {
  for (const key in V1CloudProvider) {
    if (Object.prototype.hasOwnProperty.call(V1CloudProvider, key)) {
      if (V1CloudProvider[key as keyof typeof V1CloudProvider] === value) {
        return true;
      }
    }
  }
  return false;
}

export function V1CloudProviderFromJSON(json: any): V1CloudProvider {
  return V1CloudProviderFromJSONTyped(json, false);
}

export function V1CloudProviderFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): V1CloudProvider {
  return json as V1CloudProvider;
}

export function V1CloudProviderToJSON(value?: V1CloudProvider | null): any {
  return value as any;
}

export function V1CloudProviderToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): V1CloudProvider {
  return value as V1CloudProvider;
}
